/**
 * Variable group_id en ProductFilter
 */
export enum eProductFilterGroupType {
	SHIPPING = 1,
	CITIES = 2,
	PRICES = 3,
	CATEGORIES = 4,
	STORES = 5,
	VALUABLES = 6,
	DISCOUNTS = 7
}